import { render, staticRenderFns } from "./AdminContrattiDaVisionareView.vue?vue&type=template&id=28a7eea1&"
import script from "./AdminContrattiDaVisionareView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiDaVisionareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports